import type {Job,Snapshot} from './model'
import {providerNames,waitingProvider,type ProviderHealth} from './providerHealth'
export default function ProviderWaiting({job,data}:{job?:Job;data?:Snapshot}){
 const waiting=waitingProvider(job,(data as Snapshot&{provider_health?:Record<string,ProviderHealth>})?.provider_health)
 if(!waiting)return null
 const expired=waiting.until&&Date.parse(waiting.until)<=Date.now()
 return <section className="cc-card cc-provider-waiting" dir="rtl" aria-label="למה העבודה ממתינה" role="status">
  <strong>למה ממתינים?</strong>
  <p>ספק: {providerNames[waiting.provider]??waiting.provider}</p>
  <p>סיבה: {waiting.state==='probe'||expired?'ניסיון בדיקה יחיד בודק אם הספק חזר לפעול':'הספק דיווח על מגבלת שימוש'}</p>
  {waiting.until&&<p>עד: <time dateTime={waiting.until}>{new Date(waiting.until).toLocaleString('he-IL',{timeZone:'Asia/Jerusalem',day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'})}</time> · שעון ישראל</p>}
  {waiting.signal_excerpt&&<details><summary>האות שהתקבל מהספק</summary><code dir="ltr" style={{display:'block',whiteSpace:'pre-wrap',overflowWrap:'anywhere',marginTop:8}}>{waiting.signal_excerpt}</code></details>}
  <p>העבודה נשמרת בתור. עבודות של ספקים אחרים ממשיכות.</p>
 </section>
}
